import { Checkbox } from 'antd';
import { FC } from 'react';
import styles from './DropdownStyles.module.scss';
import { DropdownColumnItemsProps } from './DropdownColumnItems.props';

const DropdownColumnItems: FC<DropdownColumnItemsProps> = ({
  checkboxOptions,
  keysOFColumnsToDisplay,
  handleCheckboxChange,
}) => (
  <div className={styles.columnsDropdownContainer}>
    <p className={styles.dropdownTitle}>Select columns</p>
    <Checkbox.Group
      style={{ display: 'flex', flexDirection: 'column' }}
      options={checkboxOptions}
      value={keysOFColumnsToDisplay}
      onChange={(e) => handleCheckboxChange(e)}
    ></Checkbox.Group>
  </div>
);

export { DropdownColumnItems };
